var exports = {
  "k": "x04b3a21e--e79363--container",
  "T": "x04b3a21e--e79363--image-wrapper",
};

module.exports = exports;
